import { useRef } from 'react';
import HeroBanner from "../../base/HeroBanner/HeroBanner";
import TopicIntro from "../../base/Topic/TopicIntro";
import SinglePage from "../SinglePage/SinglePage";
import ImpressionsContainer from "./ImpressionsContainer/ImpressionsContainer";
import OverviewContainer from "./OverviewContainer/OverviewContainer";
import { Container, HighlightLink } from "./styles";
import { smoothScrollTo } from "../../functionallity/smoothScrollTo";
import SubmitButton from "../../base/Buttons/SubmitButton/SubmitButton";
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const Home = () => {

    const navigate = useNavigate();


    const topicIntroRef = useRef<HTMLDivElement>(null);

    const scrollToTopicIntro = () => {
        if (topicIntroRef.current) {
            smoothScrollTo(topicIntroRef.current, 2000);
        }
    };

    const primaryButton = <SubmitButton text="Jetzt bewerben" onClick={() => navigate("/bewerbung")} />;
    const secondaryButton = <SubmitButton text="Kontaktiere uns" onClick={() => navigate("/kontakt")} />;

    return (
        <SinglePage
            title='Home'
            heroBanner={
                <HeroBanner
                    imageSource={require('../../../assets/images/Home/PW20230219_15-19-47DSC07732.png')}
                    headline="ECKENMOORHEXEN"
                    text="Schau dich um, lerne uns kennen und erfahre mehr über die Eckenmoorhexen."
                    onNextSection={scrollToTopicIntro}
                    primaryButton={primaryButton}
                    secondaryButton={secondaryButton}
                />
            }
            topic={
                <div ref={topicIntroRef}>
                    <TopicIntro
                        headline="NICHT VERLAUFEN."
                        introductionText={<span>Im Moor gibt es viel zu entdecken und du kannst allen davon erzählen wenn du den Weg wieder nach draußen findest. Doch bevor es dazu kommt, lerne uns kennen, entdecke unsere Geschichte, den Ursprung der Eckenmoorhexen und unser wunderschönes Hexenkleidle. Schau dich um und wenn du Fragen hast, trau dich und sprich mit uns. Wer weiß, vielleicht verfällst du den Hexen und bleibst freiwillig im Moor...für immer. <br/> Auch für unsere kleinen Hexen gibt es etwas zu entdecken. In unserer Hexenwerkstatt kannst du deine eigene Hexe basteln oder Bilder der Eckenmoorhexe ausmalen. Hol deine Stifte heraus, schneide, klebe und gestalte – erschaffe deine eigene kleine Hexenwelt und werde ein Teil des geheimnisvollen Moors. <HighlightLink as={Link} to='/hexenwerkstatt'>Klicke hier</HighlightLink> und erfahre mehr!</span>}
                    />
                </div>
            }
            content={
                <Container>
                    <OverviewContainer />
                    <ImpressionsContainer />
                </Container>
            }
        />
    );
}

export default Home;
